const Tjson = [
  {
    id: 1,
    title: "AI Image Generator",
    desc: "Generate high-quality images from text prompts instantly using AI-powered image generation.",
    goto: "Midjourney",
    link: "https://www.midjourneyai.ai/",
  },
  {
    id: 2,
    title: "AI Voice & Noise Remover",
    desc: "Enhance speech recordings for podcasts, interviews, and lectures — removing background noise automatically.",
    goto: "Adobe Enhance",
    link: "https://podcast.adobe.com/enhance",
  },
  {
    id: 3,
    title: "AI Design Assistant",
    desc: "Create posters, web banners, and social content easily using Adobe Express with Firefly AI built-in.",
    goto: "Adobe Express",
    link: "https://new.express.adobe.com/",
  },
  {
    id: 4,
    title: "Screen Recorder for Developers",
    desc: "Record, edit, and share coding tutorials with no watermark or time limits. Great for YouTube and demos.",
    goto: "Free Cam",
    link: "https://www.freescreenrecording.com/",
  },
  {
    id: 5,
    title: "Logo & Brand Designer",
    desc: "Design your own logo using AI templates. No design experience needed — free download instantly.",
    goto: "Logo.com",
    link: "https://logo.com/",
  },
  {
    id: 6,
    title: "Image Size Optimizer",
    desc: "Reduce image size without losing quality for faster website load speeds.",
    goto: "JPEG Optimizer",
    link: "https://jpeg-optimizer.com/",
  },
  {
    id: 7,
    title: "Image to Link Converter",
    desc: "Upload and convert any image into a shareable link — perfect for hosting logos and thumbnails.",
    goto: "ImgBB",
    link: "https://imgbb.com/",
  },
  {
    id: 8,
    title: "AI Resume Builder",
    desc: "Create a professional resume in minutes with templates optimized for job applications.",
    goto: "Resume.io",
    link: "https://resume.io/",
  },
  {
    id: 9,
    title: "Color Palette Generator",
    desc: "Generate perfect color palettes for your website, UI design, or brand theme instantly.",
    goto: "Coolors",
    link: "https://coolors.co/",
  },
  {
    id: 10,
    title: "Free Illustrations & Icons",
    desc: "Download modern, vector-based illustrations and icons for websites and apps.",
    goto: "Undraw",
    link: "https://undraw.co/illustrations",
  },
  {
    id: 11,
    title: "Online Code Formatter",
    desc: "Beautify, minify, and format your JavaScript, HTML, CSS, or JSON online.",
    goto: "Code Beautify",
    link: "https://codebeautify.org/",
  },
  {
    id: 12,
    title: "API Testing Platform",
    desc: "Test RESTful APIs easily using Postman — ideal for backend developers.",
    goto: "Postman",
    link: "https://www.postman.com/",
  },
  {
    id: 13,
    title: "Background Remover",
    desc: "Remove the background from any photo with a single click using AI.",
    goto: "Remove.bg",
    link: "https://www.remove.bg/",
  },
  {
    id: 14,
    title: "Image Compressor",
    desc: "Compress PNG and JPG files online without losing image quality.",
    goto: "TinyPNG",
    link: "https://tinypng.com/",
  },
  {
    id: 15,
    title: "AI Text Content Writer",
    desc: "Write professional blogs, captions, and code documentation using ChatGPT AI.",
    goto: "ChatGPT",
    link: "https://chat.openai.com/",
  },
  {
    id: 16,
    title: "Web Deployment Tool",
    desc: "Host and deploy your frontend projects easily with a few clicks.",
    goto: "Vercel",
    link: "https://vercel.com/",
  },
  {
    id: 17,
    title: "GitHub Repository Manager",
    desc: "Manage and share your coding projects with version control.",
    goto: "GitHub",
    link: "https://github.com/",
  },
  {
    id: 18,
    title: "AI Video Editor",
    desc: "Quickly remove silences, trim clips, and generate captions using AI automation.",
    goto: "Descript",
    link: "https://www.descript.com/",
  },
  {
    id: 19,
    title: "Web Mockup Generator",
    desc: "Generate responsive device mockups for showcasing your website or app.",
    goto: "Shots.so",
    link: "https://shots.so/",
  },
  {
    id: 20,
    title: "Cloud Storage & File Sharing",
    desc: "Store, sync, and share your files securely across devices.",
    goto: "Google Drive",
    link: "https://drive.google.com/",
  },
];

export default Tjson;
